module.exports = __webpack_public_path__ + "0182add6de926dd5bd3c357351351f01.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/Gwlogo2.png
// module id = 148
// module chunks = 0